import { render, staticRenderFns } from "./ModalProductSlider.vue?vue&type=template&id=1a4fa56a&scoped=true&"
import script from "./ModalProductSlider.vue?vue&type=script&lang=js&"
export * from "./ModalProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductSlider.vue?vue&type=style&index=0&id=1a4fa56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4fa56a",
  null
  
)

export default component.exports